module.exports = __webpack_public_path__ + "static/media/vmove_companies.3e8b28b6.svg";